import {
  BookingForm,
  IntroSection,
  AdvantageSection,
  ReviewsSection
} from '../../components';

const AboutUs = () => {
  return (
    <section id="about">
      <BookingForm />
      <IntroSection />
      <AdvantageSection />
      <ReviewsSection />
    </section>
  );
};

export default AboutUs;
